/* global Swiper */

/**
 * @file
 * Categories slider functionality.
 */

((Drupal, once) => {

  /**
   * Initialize slider functionality.
   *
   * @param props
   */
  function initSlider(props) {
    const _options = {
      slidesPerView: 'auto',
      spaceBetween: 0,
      touchEventsTarget: 'container',
      centeredSlides: true,
      grabCursor: true,
      pagination: {
        el: '.slider__pagination--categories-slider',
      },
      breakpoints: {
        992: {
          centeredSlides: false,
          slidesPerView: 4.5,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40,
        },
      },
    };

    new Swiper(props._$slider, _options);
  }

  /**
   * Initialize categories slider.
   *
   * @param props
   */
  function init(props) {
    initSlider(props);
  }

  Drupal.behaviors.categoriesSlider = {
    attach(context) {
      const _$categoriesSlider = once('slider', '[data-slider-categories-slider]', context);

      // If there are categories sliders.
      if (_$categoriesSlider) {
        _$categoriesSlider.forEach(_$slider => {
          init({_$slider});
        });
      }
    },
  };
})(Drupal, once);
